export const startingBoard = ["", "", "", "", "", ""]